import { render } from "./Algorithm.vue?vue&type=template&id=3c635898"
import script from "./Algorithm.vue?vue&type=script&lang=js"
export * from "./Algorithm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__